import React, { Component } from 'react'
import { Button, Form, Table, Modal, Input, message, Icon, Switch, Select } from 'antd'
import {
  getWxPayMchConfig,
  addWxPayMchConfig,
  reviseWxPayMchConfig,
  deleteWxPayMchConfig,
} from '_src/api/api'

const { TextArea } = Input
const { confirm } = Modal

@Form.create({ name: 'WxPayMchConfig' })
class WxPayMchConfigPage extends Component {
  constructor (props) {
    super(props)
    this.id = ''
    this.param = { pageNum: 0, totalElements: 0 }
    this.state = { loading: true, visible: false, dataList: [] }
  }

  componentDidMount () {
    this.loadData()
  }

  loadData () {
    this.setState({ loading: true })
    getWxPayMchConfig({ pageSize: 10, pageNum: this.param.pageNum })
      .then(res => {
        const { content, totalElements } = res.data
        this.param.totalElements = totalElements
        this.setState({
          dataList: (content || []).map((item, index) => ({ ...item, key: item.id, sort: index + 1 })),
          visible: false,
          loading: false,
        })
      })
      .catch(() => this.setState({ loading: false }))
  }

  columns = () => ([
    { title: '排序', align: 'center', dataIndex: 'sort', key: 'sort' },
    { title: '商户号', align: 'center', dataIndex: 'mchId', key: 'mchId' },
    { title: '名称', align: 'center', dataIndex: 'name', key: 'name' },
    { title: 'API版本', align: 'center', dataIndex: 'apiVersion', key: 'apiVersion' },
    {
      title: '私钥PEM',
      align: 'center',
      dataIndex: 'hasPrivateKeyPem',
      render: v => (v
        ? <Icon type="check-circle" theme="twoTone" style={{ color: 'green', fontSize: 20 }} />
        : <Icon type="close-circle" theme="filled" style={{ color: '#ccc', fontSize: 20 }} />),
    },
    {
      title: '启用',
      align: 'center',
      dataIndex: 'enabled',
      render: item => (item === 1
        ? <Icon type="check-circle" theme="twoTone" style={{ color: 'green', fontSize: 20 }} />
        : <Icon type="close-circle" theme="filled" style={{ color: '#ccc', fontSize: 20 }} />),
    },
    {
      title: '操作',
      align: 'center',
      render: (_, record) => (
        <div>
          <Button icon="form" type="primary" style={{ marginRight: 10 }} onClick={() => this.onEdit(record)}>编辑</Button>
          <Button icon="stop" type="danger" onClick={() => this.handleDisable(record)}>禁用</Button>
        </div>
      ),
    },
  ])

  onEdit (record) {
    const { id } = record || {}
    this.id = id || ''
    this.setState({ visible: true }, () => {
      const r = record || {}
      this.props.form.setFieldsValue({
        enabled: r.enabled !== 0,
        mchId: r.mchId || '',
        name: r.name || '',
        apiVersion: r.apiVersion || 'v3',
        apiV2Key: '',
        apiV3Key: '',
        merchantSerialNo: r.merchantSerialNo || '',
        privateKeyPem: '',
        privateKeyPath: r.privateKeyPath || '',
      })
    })
  }

  handleDisable = (record) => {
    const _self = this
    confirm({
      title: '温馨提示',
      content: (<p>禁用后新单不可再绑定该商户，历史订单退款仍可用。确定禁用 <strong style={{ color: 'red' }}>{record.mchId}</strong>？</p>),
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk () {
        deleteWxPayMchConfig(record.id).then(() => _self.loadData())
      },
    })
  }

  onSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (err) return
      const hide = message.loading(this.id ? '修改中' : '添加中', 0)
      const param = {
        ...values,
        enabled: values.enabled !== false,
        apiV2Key: values.apiV2Key || undefined,
        apiV3Key: values.apiV3Key || undefined,
        privateKeyPem: values.privateKeyPem || undefined,
      }
      const req = this.id
        ? reviseWxPayMchConfig(this.id, param)
        : addWxPayMchConfig(param)
      req.then(() => {
        hide()
        message.success('保存成功', 1.5)
        this.loadData()
      }).catch(() => {
        hide()
        message.error('保存失败', 1.5)
      })
    })
  }

  render () {
    const { dataList, visible, loading } = this.state
    const { getFieldDecorator } = this.props.form
    return (
      <div className="page_content">
        <div className="simple_top">
          <Button type="primary" icon="plus" onClick={() => this.onEdit()}>添加商户</Button>
        </div>
        <Table
          loading={loading}
          bordered
          columns={this.columns()}
          dataSource={dataList}
          pagination={{
            current: this.param.pageNum + 1,
            total: this.param.totalElements,
            onChange: (page) => { this.param.pageNum = page - 1; this.loadData() },
          }}
        />
        <Modal
          title="微信支付商户配置"
          width={720}
          visible={visible}
          onCancel={() => this.setState({ visible: false })}
          footer={false}
          destroyOnClose
        >
          <Form onSubmit={this.onSubmit} labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
            <Form.Item label="启用">
              {getFieldDecorator('enabled', { valuePropName: 'checked', initialValue: true })(<Switch />)}
            </Form.Item>
            <Form.Item label="商户号">
              {getFieldDecorator('mchId', { rules: [{ required: true, message: '必填' }] })(
                <Input placeholder="微信商户号" disabled={!!this.id} />
              )}
            </Form.Item>
            <Form.Item label="名称">
              {getFieldDecorator('name')(<Input placeholder="备注名称" />)}
            </Form.Item>
            <Form.Item label="API版本">
              {getFieldDecorator('apiVersion', { initialValue: 'v3' })(
                <Select>
                  <Select.Option value="v3">v3</Select.Option>
                  <Select.Option value="v2">v2</Select.Option>
                </Select>
              )}
            </Form.Item>
            <Form.Item label="APIv3密钥">
              {getFieldDecorator('apiV3Key')(<Input.Password placeholder="编辑留空表示不修改" />)}
            </Form.Item>
            <Form.Item label="证书序列号">
              {getFieldDecorator('merchantSerialNo')(<Input placeholder="merchantSerialNo" />)}
            </Form.Item>
            <Form.Item label="私钥PEM">
              {getFieldDecorator('privateKeyPem')(
                <TextArea rows={6} placeholder="粘贴完整 PEM（含 BEGIN/END）；编辑留空不修改" />
              )}
            </Form.Item>
            <Form.Item label="APIv2密钥">
              {getFieldDecorator('apiV2Key')(<Input.Password placeholder="仅 v2 需要；留空不修改" />)}
            </Form.Item>
            <Form.Item label="私钥文件路径">
              {getFieldDecorator('privateKeyPath')(<Input placeholder="可选，默认 {mchId}_key.pem" />)}
            </Form.Item>
            <Form.Item style={{ paddingLeft: 140 }}>
              <Button type="primary" htmlType="submit" icon="save" style={{ width: 248 }}>保存</Button>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    )
  }
}

export default WxPayMchConfigPage
